
import { SoftDeleteEntity } from './soft-delete-entity';
import {Upload} from './upload';
import {IdvUploadDto} from './idv-upload';

export class CustomerIdvDocsStatusDto extends SoftDeleteEntity {
    typeId: number;
    isSuccess: boolean;
    customerId: number;
    files: IdvUploadDto[];
}
